import React from 'react';
import { useSelector } from 'react-redux';
import { carClassDetailsSelector, guaranteedResCardRequiredSelector } from 'selectors/reservationSelectors';
import { selectedExtras } from 'selectors/extrasSelectors';
import { formattedPoliciesSelector } from 'selectors/policiesSelectors';
import GLOBAL from 'constants/global';
import MODAL from 'constants/modals';
import ModifyReservationModal from 'components/modals/ModifyReservationModal';
import ReviewRentalDetails from 'components/ReservationFlow/Review/ReviewRentalDetails';
import CurrencyConversionModal from 'components/modals/CurrencyConversionModal';
import TaxesModal from 'components/modals/TaxesModal';
import useActions from 'hooks/useActions';
import { openModal } from 'actions/modal/openModal';

/**
 * Skip The Counter Info Component
 * Sidebar that displays the current step info during Skip The Counter Flow.
 *
 * @return {JSX} SkipTheCounterStepInfo jsx component
 */
const SkipTheCounterLeftSide = ({ stepTwo }) => {
  const carClassDetails = useSelector(carClassDetailsSelector);
  const isVehicleLimitedInventory = carClassDetails?.status?.indexOf(GLOBAL.LIMITED_INVENTORY_CAR_CODE) !== -1;
  const extras = useSelector(selectedExtras);
  const policies = useSelector(formattedPoliciesSelector);
  const guaranteedResCardRequired = useSelector(guaranteedResCardRequiredSelector);
  const showLearnMoreModal = useActions(() => openModal(MODAL.CURRENCY_CONVERSION_DETAILS_MODAL));

  return (
    <section className='skip-the-counter-template__sidebar'>
      <div className='review__aside'>
        <div className='review__rental-details'>
          <ReviewRentalDetails
            hideEditButtons
            stcModifyButton
            policies={policies}
            extras={extras}
            isVehicleLimitedInventory={isVehicleLimitedInventory}
            allowLimitedInventoryIconExtra
            isGuaranteedRes={guaranteedResCardRequired}
            isSTCFlow
            showLearnMoreModal={showLearnMoreModal}
            stepTwo={stepTwo}
          />
        </div>
      </div>
      <ModifyReservationModal isSTCFlow={true} isTrueModify={true} />

      <TaxesModal />

      <CurrencyConversionModal />
    </section>
  );
};

export default SkipTheCounterLeftSide;
